var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClipBoard(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 29 29",
    width: "100%",
    className: "css-13o7eu2 e17sjy4w0",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.2 12.25a7.36 7.36 0 000-10.09 6.67 6.67 0 00-9.7 0L10.62 8.3a7.36 7.36 0 00.79 10.79l1.88-1.96a4.55 4.55 0 01-.82-6.9l5.88-6.14a4.12 4.12 0 016 0 4.55 4.55 0 010 6.25l-1.37 1.43c.36 1.03.56 2.12.6 3.22l2.61-2.73z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.9 16.18a7.36 7.36 0 000 10.09 6.67 6.67 0 009.7 0l5.88-6.13a7.36 7.36 0 00-.79-10.79l-1.88 1.96a4.55 4.55 0 01.82 6.9l-5.88 6.13a4.12 4.12 0 01-6 0 4.55 4.55 0 010-6.24l1.37-1.43a10.9 10.9 0 01-.6-3.22l-2.61 2.73z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClipBoard);
export default __webpack_public_path__ + "static/media/clipBoard.2b7a27dd629ab0d8ddb3f716c33a8a3b.svg";
export { ForwardRef as ReactComponent };